

<app-header class="shadow bg-dark p-1 position-fixed w-100 top-0 d-flex justify-content-between"></app-header>
<main>
  <router-outlet></router-outlet>
</main>

@if (authorized) {
  <app-overlay-legend></app-overlay-legend>
  <app-footer></app-footer>
}

<app-toasts></app-toasts>